<div class="d-flex align-items-center">
  @for (logoUrl of flightItineraries | getUniqAirlinesLogos; track logoUrl) {
    <div class="d-flex align-items-center justify-content-center logo-container">
      <img [src]="logoUrl" class="logo" alt="logo" />
    </div>
  }
</div>
